import { useState, useEffect } from 'react'
import { VerificationCountdown, VerifyTimeout, WaitingForEvents } from '@afterpaytouch/registration'
import { useCashAppConsumerName, useConsumerName, useConsumerSelector, useIsConsumerLendingOrder, useRegistrationDataName } from '../../state'
import { DesignLanguage, useIsDesignLanguage } from '@afterpaytouch/core'
import { Route } from '../../config/router'
import { ProfileCardProps } from '../ProfileCard'

export const useVerifyCountdown = (countDown: number): VerificationCountdown => {
  if (countDown < 0) {
    return {
      seconds: 0,
      minutes: 0,
    }
  }

  const seconds = Math.floor(countDown / 1000) % 60
  const minutes = Math.floor(countDown / 1000 / 60)

  return {
    seconds,
    minutes,
  }
}

const SEND_CODE_EVENT_TIME_OUT_TIME = 10000

export const useVerifyTimeout = (): VerifyTimeout => {
  const [verifyTimeout, setVerifyTimeout] = useState(false)
  const [timeoutId, setTimeoutId] = useState<null | NodeJS.Timeout>(null)
  const [waitingFor, setWaitingFor] = useState<WaitingForEvents>(WaitingForEvents.WAIT)

  const startVerifyTimeoutTimer = (waitingFor: WaitingForEvents, waitingTime = 0): void => {
    const id = setTimeout(() => {
      setVerifyTimeout(true)
    }, SEND_CODE_EVENT_TIME_OUT_TIME + waitingTime)
    setTimeoutId(id)
    setWaitingFor(waitingFor)
  }

  const killVerifyTimeoutTimer = (): void => {
    setVerifyTimeout(false)
    if (timeoutId != null) {
      clearTimeout(timeoutId)
    }
    setTimeoutId(null)
  }

  useEffect(() => {
    return () => {
      if (timeoutId != null) {
        clearTimeout(timeoutId)
      }
    }
  }, [timeoutId])

  return { waitingFor, verifyTimeout, startVerifyTimeoutTimer, killVerifyTimeoutTimer }
}

export const useSummaryRoute = (): Route => {
  const isLendingFlow = useIsConsumerLendingOrder()

  return isLendingFlow ? Route.CONSUMER_LENDING_SUMMARY : Route.SUMMARY
}

export const useProfileCardProps = (): ProfileCardProps => {
  const isArcadeDesignLanguage = useIsDesignLanguage(DesignLanguage.Arcade)
  const profileConsumerName = useConsumerName()
  const cashAppConsumerName = useCashAppConsumerName()
  const { email } = useConsumerSelector()
  const registrationDataName = useRegistrationDataName()
  const consumerName = profileConsumerName.length > 0 ? profileConsumerName : cashAppConsumerName

  if (isArcadeDesignLanguage) {
    return {
      // if consumerName is empty, use registrationDataName
      // if registrationDataName is empty, ProfileCard use customSubheader
      header: consumerName.length > 0 ? consumerName : registrationDataName,
      customSubheader: email,
      hideSubheader: false,
    }
  }

  return {}
}
